import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';
import { SEARCH_ACTIONS } from 'src/actions/SearchActions';
import { searchSaga } from 'src/sagas/searchSaga';
import { locationSaga } from 'src/sagas/locationSaga';
import { SUGGEST_ACTIONS } from 'src/actions/SuggestActions';
import { suggestSaga } from 'src/sagas/suggestSaga';

export function* rootSaga(): SagaIterator {
    yield takeLatest(SEARCH_ACTIONS.REQUEST, searchSaga);
    yield takeLatest(SUGGEST_ACTIONS.REQUEST, suggestSaga);
    yield takeLatest(LOCATION_CHANGE, locationSaga);
}
